import { devicePairingApiClient } from "@api-client/device_pairing";
import { toast } from "@/ui-plus/sonner";
import { generateOTPJsOnly } from "@lib/utils/generateRandomOtp";
import { ref } from "vue";
import { loadMyStores } from "./MyStoresStore";
import PusherJS from 'pusher-js';
import { setAuthState, startRefreshingTokens } from "@api-client/auth/auth";
import { addListeningStore } from "./MySettingsStore";

let devicePairingPusherClient: PusherJS | null = null;
let channel: ReturnType<PusherJS['subscribe']> | null = null;
let timeOutId: NodeJS.Timeout | null = null;
let token1: string | null = null;
export const isPairing = ref(false);
export const pairingCode = ref('');

export const stopPairing = () => {
    if (isPairing.value === false) {
        return;
    }
    isPairing.value = false;
    pairingCode.value = '';
    toast.info('Pairing stopped');
    if (channel) {
        channel.unsubscribe();
        channel.unbind_all();
        channel = null;
    }
    if (devicePairingPusherClient) {
        devicePairingPusherClient.unbind_all();
        devicePairingPusherClient.disconnect();
        devicePairingPusherClient = null;
    }
    if (timeOutId) {
        clearTimeout(timeOutId);
        timeOutId = null;
    }
    token1 = null;
}



export const onClickPairDevice = async () => {
    if (channel || devicePairingPusherClient) {
        stopPairing();
    }
    pairingCode.value = '';
    isPairing.value = true;
    const otp = generateOTPJsOnly(6);
    // const otp = "Q1W2E3";
    // wait for 1 second
    // await new Promise(resolve => setTimeout(resolve, 1000));
    if (devicePairingPusherClient) {
        toast.info('Pairing already in progress');
        return;
    }

    devicePairingPusherClient = newDevicePairingPusherClient();
    channel = devicePairingPusherClient.subscribe(`private-devicepairing.${otp}`);
    pairingCode.value = otp;
    setTimeout(() => {
        toast.info(`one-time-pairing-code: ${otp}`);
    }, 500)
    channel.bind('pair_token', async function (data: any) {
        if (data.error) {
            toast.error(data.error);
        } else if (data.token2 && token1) {
            const { data: matchData, error } = await (await devicePairingApiClient.device_pair_token_match.$post({
                json: {
                    token1: token1,
                    token2: data.token2
                }
            })).json();
            if (error) {
                toast.error(error.message || "Unknown error");
            } else {
                // if matchData is string, then it is a storeId
                if (matchData.token) {
                    await setAuthState(matchData.token);
                } else {
                    // wait for 1 second
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    await startRefreshingTokens().then(async () => {
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        addListeningStore(matchData.storeId);
                    });
                }
                setTimeout(() => {
                    toast.success(`Success! PAIRED STORE: ${data.storeName || matchData.storeId}`);
                }, 1000);
            }
        }
        stopPairing();
        loadMyStores();
    });
    devicePairingPusherClient.connection.bind('error', function () {
        toast.error('Connection error stopping');
        stopPairing();
    });
    devicePairingPusherClient.connection.bind('state_change', function (states: any) {
        if (states.current === 'disconnected') {
            stopPairing();
        } else if (states.current === 'connected') {
            console.log('new pairing started...');
            // toast.info('new pairing started...');
        }
    });
    if (timeOutId) {
        clearTimeout(timeOutId);
    }
    timeOutId = setTimeout(() => {
        stopPairing();
    }, 300_000); // 5 minutes
}

export const getHostname = function () {
    try {
        return `${require('os').hostname()}-${Date.now()}`;
    } catch (error) {
        // Fallback to browser API if running in browser environment
        const name = navigator.userAgent.substring(navigator.userAgent.indexOf('(') + 1, navigator.userAgent.indexOf(')')) || window.location.hostname || 'unknown-device';
        return `${name}-${Date.now()}`;
    }
}

const newDevicePairingPusherClient = () => {
    token1 = null;
    return new PusherJS(import.meta.env.PUBLIC_SOKETI_APP_KEY, {
        wsPath: '/soketi',
        wsHost: `soketi.${import.meta.env.PUBLIC_DOMAIN_NAME}`,
        cluster: 'cluster',
        forceTLS: true,
        enabledTransports: [
            'ws',
            'wss'
        ],
        authorizer: (channel) => {
            return {
                authorize: async (socketId, callback) => {
                    const { data, error } = await (await devicePairingApiClient.device_pairing_pusher_auth.$post({
                        json: {
                            socket_id: socketId,
                            channel_name: channel.name,
                            name: getHostname(),
                            otp: channel.name.replace('private-devicepairing.', '')
                        }
                    })).json();
                    if (error) {
                        setTimeout(() => {
                            toast.error(error.message || "Unknown error");
                        }, 500);
                        stopPairing();
                        callback(new Error(error.message || "Unknown error"), null);
                    } else {
                        token1 = data.token1;
                        callback(null, data.authSignature);
                    }
                }
            };
        },
    });
}

